"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var SvgBluetoothSignal = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
    React.createElement("path", { d: "m2.667 9.333 16 13.334-8 6.666V2.667l8 6.666-16 13.334m24.192-14A12.5 12.5 0 0 1 29.22 16c0 2.737-.875 5.27-2.36 7.333M22.667 11.81A7.3 7.3 0 0 1 23.98 16a7.3 7.3 0 0 1-1.314 4.19" }))); };
exports.default = SvgBluetoothSignal;
//# sourceMappingURL=BluetoothSignal.js.map